import { useState } from 'react'
import toast from 'react-hot-toast'
import {fetchWithAuth} from '../../libs/apiUtils'
import Modal from '../Modal'
import { StarIcon } from '@heroicons/react/24/outline'

interface CreateGroupModalProps {
  isOpen: boolean
  setIsOpen: (open: boolean) => void
  onSuccess: () => void
  defaultMode?: boolean
}

export default function CreateGroupModal({ 
  isOpen, 
  setIsOpen, 
  onSuccess,
  defaultMode = false,
}: CreateGroupModalProps) {
  const [name, setName] = useState('')
  const [loading, setLoading] = useState(false)

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (!name.trim()) return toast.error('Group name cannot be empty')

    try {
      setLoading(true)
      const res = await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/api/group`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        // isDefault is set automatically based on which tab triggered the modal
        body: JSON.stringify({ name, isDefault: defaultMode }),
      })

      const data = await res.json()

      if (!res.ok || !data.success) {
        toast.error(data.message || data[0]?.message || 'Error creating group')
        return
      }

      toast.success('Group created successfully')
      setName('')
      setIsOpen(false)
      onSuccess()
    } catch (err) {
      toast.error('Network error, check your connection')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
      <div className="mb-4">
        <h3 className="text-xl font-bold text-neutral-800">
          {defaultMode ? 'Tambah Grup Bawaan' : 'Tambah Grup Baru'}
        </h3>
        {defaultMode && (
          <p className="mt-1 flex items-center gap-1.5 text-xs text-amber-700 font-medium">
            <StarIcon className="size-3.5" />
            Grup ini akan terlihat oleh semua admin dan kategorinya tidak dapat diubah oleh mereka.
          </p>
        )}
      </div>
      <form onSubmit={handleSubmit}>
        <div className="mb-6">
          <label htmlFor="group-name" className="block text-sm font-semibold text-neutral-600 mb-2">
            Nama Grup
          </label>
          <input
            type="text"
            id="group-name"
            className="border border-neutral-300 px-4 py-2 rounded-lg w-full focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-all outline-none"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Contoh: Infrastruktur Dasar"
            autoFocus
          />
        </div>
        <div className="flex justify-end gap-3">
          <button
            type="button"
            className="px-4 py-2 text-neutral-600 font-medium rounded-lg hover:bg-neutral-100 transition-colors"
            onClick={() => setIsOpen(false)}
            disabled={loading}
          >
            Batal
          </button>
          <button
            type="submit"
            className="bg-primary-600 text-white px-6 py-2 rounded-lg font-semibold hover:bg-primary-700 active:scale-95 disabled:opacity-50 disabled:active:scale-100 transition-all"
            disabled={loading}
          >
            {loading ? 'Menyimpan...' : 'Tambahkan Grup'}
          </button>
        </div>
      </form>
    </Modal>
  )
}
